// JS For Header dropdown            
			document.getElementById('custom_dropdown_open').onclick = function(){ 
                var el = document.getElementById('custom-country-selecter');
                if ( el.style.display == 'block' )
                {
                    el.style.display = 'none';
                }
                else {
                    el.style.display = 'block';
                };
            };
              
              window.addEventListener('click', function(e){   
                 var el = document.getElementById('custom-country-selecter');
              if (document.getElementById('custom_dropdown_open').contains(e.target)){
                
                // Clicked in box
              } else{
                el.style.display = 'none';
              }
            });
            
// END JS For Header dropdown 


// JS For Footer dropdown 
		document.getElementById('custom_dropdown_open1').onclick = function(){ 
                var el = document.getElementById('custom-country-selecter1');
                if ( el.style.display == 'block' )
                {
                    el.style.display = 'none';
                }
                else {
                    el.style.display = 'block';
                };
            };
              
              window.addEventListener('click', function(e){   
                 var el = document.getElementById('custom-country-selecter1');
              if (document.getElementById('custom_dropdown_open1').contains(e.target)){
                
                // Clicked in box
              } else{
                el.style.display = 'none';
              }
            });

// END JS For Footer dropdown 





// JS For Mobile sidebar dropdown
 

          document.getElementById('custom_dropdown_open2').onclick = function(){ 
                var el = document.getElementById('custom-country-selecter2');
                if ( el.style.display == 'block' )
                {
                    el.style.display = 'none';
                }
                else {
                    el.style.display = 'block';
                };
            };
              
              window.addEventListener('click', function(e){   
                 var el = document.getElementById('custom-country-selecter2');
              if (document.getElementById('custom_dropdown_open2').contains(e.target)){
                
                // Clicked in box
              } else{
                el.style.display = 'none';
              }
            });
// End JS For Mobile sidebar dropdown